// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__UuMXM","buttons":"SendReceipts_buttons__34Xna","email":"SendReceipts_email__2cnbn","bookApptTitle":"SendReceipts_bookApptTitle__25r4o"};